export default {"theme":{"dark":false,"themes":{"light":{"primary":"#1976D2","secondary":"#424242","accent":"#82B1FF","error":"#FF5252","info":"#2196F3","success":"#4CAF50","warning":"#FB8C00"}}}}
